import { useEffect } from 'react'
import { RefreshDigitalSignatureStatusClientRequest } from '../../@types/digitalSignature/RefreshDigitalSignatureStatus'
import { ENV } from '../../Environment'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useCreateProposalStore } from '../../Stores/useCreateProposalStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'
import { useSendDigitalSignatureStore } from '../../Stores/useSendDigitalSignatureStore'
import { useRefreshDigitalSignatureStatus } from '../../hooks/api/digitalSignature/useRefreshDigitalSignatureStatus'

export const PROPOSAL_DOCUMENT_TEMPLATE_CODE = 'PETIS_PRP'

export const usePayloadRefreshDigitalSignatureStatus = () => {
  const { createProposal } = useCreateProposalStore()
  const { sendDigitalSignature } = useSendDigitalSignatureStore()
  const { generateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { setIsLoadingRefreshDigitalSignatureStatus } =
    useRefreshDigitalSignatureStatusStore()
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()

  const {
    mutate,
    isLoading: isLoadingRefresh,
    isSuccess: isSuccessRefresh,
    isError: isErrorRefresh,
  } = useRefreshDigitalSignatureStatus()

  const getProposalDocumentKeyRef =
    generateProposalDocuments?.documentstoList?.find(
      (doc) => doc.templateCode === PROPOSAL_DOCUMENT_TEMPLATE_CODE,
    )?.keyRef || ''

  const payload: RefreshDigitalSignatureStatusClientRequest = {
    policyId: createProposal?.createProposalResponse?.proposalId || '',
    signatureId: sendDigitalSignature?.digitalSignature?.signatureId || '',
    keyRef: getProposalDocumentKeyRef,
    policyHolderFiscalNumber: policyholderDetailsSelected?.vatNumber || '',
    policyHolderId: policyholderDetailsSelected?.idEntity || '',
    accessType: 'S',
    branchCode: ENV().BranchCode, //TODO: Review
    applicationCode: ENV().ApplicationCode || '',
    originTemplate: '', //TODO: No data available, review
  }

  const handleRefreshDigitalSignature = () => {
    mutate(payload)
  }

  const handleRefreshDigitalSignatureResume = (
    resumePayload: RefreshDigitalSignatureStatusClientRequest,
  ) => {
    mutate({
      ...resumePayload,
      accessType: 'S',
      branchCode: ENV().BranchCode, //TODO: Review
      applicationCode: ENV().ApplicationCode || '',
      originTemplate: '', //TODO: No data available, review
    })
  }

  useEffect(() => {
    setIsLoadingRefreshDigitalSignatureStatus(isLoadingRefresh)
  }, [isLoadingRefresh])

  return {
    handleRefreshDigitalSignature,
    handleRefreshDigitalSignatureResume,
    isLoadingRefresh,
    isSuccessRefresh,
    isErrorRefresh,
  }
}
